const state = {
  /*换肤*/
  skin: {},
  /*POST请求携带token*/
  token: false,
  datumValue: 4,
  datumObj: 2,
  /*菜单选中key*/
  menuActiveName: '',
  /*菜单自动展开key*/
  menuOpenName: [],
  /*页码数*/
  pageSize: 10,
  /*大模态框状态（已废弃）*/
  modelDisabled: true,
  /*面包屑*/
  crumbsList: [],
  /*菜单列表*/
  menuList: [],
  /*不显示头routername */
  hideRouterName: ['play', 'questionnairepaper', 'paper', 'paperresult', 'exampractice', 'retrieve', 'resetPasswords', 'resetPhone', 'bindPhone', 'exercise'],
  /*设置特定router背景颜色 */
  bgRouter: {
    '#eee': ['paper', 'paperresult']
  }
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js